export const DEV_EXT_ID = 'chkfdipjdldekkcflcflmaopfioieiem'

// Storage local variables
export const PREFFERRED_MIC_SETTING = 'STORAGE_LOCAL/PREFERRED_MIC'
export const REC_PANEL_VISIBILITY = 'STORAGE_LOCAL/REC_PANEL_VISIBILITY'
export const REC_CHAPTER_COUNT = 'STORAGE_LOCAL/REC_CHAPTER_COUNT'
export const LINK_REPLACER_FEATURE = 'STORAGE_LOCAL/LINK_REPLACER_FEATURE'
export const WEBCAM_SETTING = 'STORAGE_LOCAL/WEBCAM_SETTING'
export const SPACE_FILTER_STATE = 'STORAGE_LOCAL/SPACE_FILTER_STATE'
